// extracted by mini-css-extract-plugin
export default {"share-button":"_0PiM84","shareButton":"_0PiM84"};